var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22461 9.89941C6.59151 9.89941 7.7002 11.0081 7.7002 12.375V15.125C7.70009 16.4918 6.59145 17.5996 5.22461 17.5996H2.47461C1.10786 17.5995 0.000105284 16.4917 0 15.125V12.375C0 11.0082 1.10779 9.89952 2.47461 9.89941H5.22461ZM15.125 9.89941C16.4918 9.89952 17.5996 11.0082 17.5996 12.375V15.125C17.5995 16.4918 16.4918 17.5995 15.125 17.5996H12.375C11.0082 17.5996 9.89952 16.4918 9.89941 15.125V12.375C9.89941 11.0081 11.0081 9.89941 12.375 9.89941H15.125ZM5.22461 0C6.59145 0 7.70009 1.10779 7.7002 2.47461V5.22461C7.7002 6.59151 6.59151 7.7002 5.22461 7.7002H2.47461C1.10779 7.70009 0 6.59145 0 5.22461V2.47461C0.000105583 1.10786 1.10786 0.000105582 2.47461 0H5.22461ZM15.125 0C16.4918 0.000105285 17.5995 1.10786 17.5996 2.47461V5.22461C17.5996 6.59145 16.4918 7.70009 15.125 7.7002H12.375C11.0081 7.7002 9.89941 6.59151 9.89941 5.22461V2.47461C9.89952 1.10779 11.0082 0 12.375 0H15.125Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cf3d7700c1996e9b2a3c612dbaa1cc62.svg";
export { ForwardRef as ReactComponent };